import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// Link
import { Link } from "react-router-dom";
// Sections for this page
import AboutTenSection from "./Sections/AboutTenSection.jsx";
import DomainsSection from "./Sections/DomainsSection.jsx";
import CapabilityExplorerSection from "./Sections/CapabilityExplorerSection.jsx";
import PDProgramSection from "./Sections/PDProgramSection.jsx";
import BottomNavSection from "./Sections/BottomNavSection.jsx";
import FooterSection from "./../PortalPage/Sections/FooterSection.jsx";
// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import cataloguePageStyle from "assets/jss/material-kit-pro-react/views/cataloguePageStyle.jsx";

class TenPage extends React.Component {
  componentDidMount() {
    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (window.location.href.lastIndexOf("#") > 0)
      document.getElementById(href).scrollIntoView();
    window.addEventListener("scroll", this.updateView);
    this.updateView();
  }
  componentDidUpdate() {
    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    document.getElementById(href).scrollIntoView();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateView);
  }
  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
  updateView() {
    var contentSections = document.getElementsByClassName("cd-section");
    var navigationItems = document
      .getElementById("cd-vertical-nav")
      .getElementsByTagName("a");

    for (let i = 0; i < contentSections.length; i++) {
      var activeSection =
        parseInt(navigationItems[i].getAttribute("data-number"), 10) - 1;
      if (
        contentSections[i].offsetTop -
          window.innerHeight / 2 +
          document.getElementById("main-panel").offsetTop <
          window.pageYOffset &&
        contentSections[i].offsetTop +
          contentSections[i].scrollHeight -
          window.innerHeight / 2 +
          document.getElementById("main-panel").offsetTop >
          window.pageYOffset
      ) {
        navigationItems[activeSection].classList.add("is-selected");
      } else {
        navigationItems[activeSection].classList.remove("is-selected");
      }
    }
  }

  smoothScroll(target) {
    var targetScroll = document.getElementById(target);
    this.scrollTo(document.documentElement, targetScroll.offsetTop, 900);
  }
  scrollTo(element, to, duration) {
    var start = element.scrollTop,
      change = to - start + document.getElementById("main-panel").offsetTop,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = this.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    }.bind(this);
    animateScroll();
  }

  render() {
    const { classes, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
    return (
      <div>
        <Header
          color="transparent"
          brand="TEN Gateway"
          links={<HeaderLinks dropdownHoverColor="primary" />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/books-shelves.jpeg")} />
        <div
          className={classNames(classes.main, classes.mainRaised)}
          id="main-panel"
        >
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <div className={classes.profile}>
                    <div className={classes.name}>
                      <h1 className={classes.title}>About TEN</h1>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <div
                className={classNames(classes.section, "cd-section")}
                id="aboutten"
              >
                <AboutTenSection />
              </div>
              <div
                className={classNames(classes.section, "cd-section")}
                id="framework"
              >
                <DomainsSection />
              </div>
              <div
                className={classNames(classes.section, "cd-section")}
                id="pdprogram"
              >
                <PDProgramSection />
              </div>
              <div
                className={classNames(classes.section, "cd-section")}
                id="capabilityexplorer"
              >
                <CapabilityExplorerSection />
              </div>
              <BottomNavSection />
            </div>
          </div>
        </div>
        <nav id="cd-vertical-nav">
          <ul>
            <li>
              <a
                href="#aboutten"
                data-number="1"
                className=""
                onClick={e => {
                  e.preventDefault();
                  this.smoothScroll("aboutten");
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">About Ten</span>
              </a>
            </li>
            <li>
              <a
                href="#pdprogram"
                data-number="2"
                className=""
                onClick={e => {
                  e.preventDefault();
                  this.smoothScroll("framework");
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Framework</span>
              </a>
            </li>
            <li>
              <a
                href="#pdprogram"
                data-number="3"
                className=""
                onClick={e => {
                  e.preventDefault();
                  this.smoothScroll("pdprogram");
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">PD Program</span>
              </a>
            </li>
            <li>
              <a
                href="#capabilityexplorer"
                data-number="4"
                className=""
                onClick={e => {
                  e.preventDefault();
                  this.smoothScroll("capabilityexplorer");
                }}
              >
                <span className="cd-dot" />
                <span className="cd-label">Capability Explorer</span>
              </a>
            </li>
          </ul>
        </nav>
        <FooterSection />
      </div>
    );
  }
}

export default withStyles(cataloguePageStyle)(TenPage);
